export default "__VITE_ASSET__ziNeFvxB__"